/**
 * Segment / legend colour per event status (Figma order) — the donut segment
 * and its legend entry share the same colour.
 */
export const STATUS_COLORS = {
  completed: "var(--color-primary-300)",
  upcoming: "var(--color-fuchsia-500)",
  ongoing: "var(--color-primary-default)",
  pending: "var(--color-warning-hover)",
  cancelled: "var(--color-destructive-default)",
};

/** Donut segments run in this order (clockwise from 12); the legend keeps data order. */
export const CHART_SEGMENT_ORDER = [
  "completed",
  "pending",
  "cancelled",
  "ongoing",
  "upcoming",
];
